import { ReactNode } from "react";
import StatusBox, { StatusBoxProps } from "./StatusBox";
import { StackProps, TypographyProps, Stack, Typography } from "@mui/material";

export interface RefundStatusBoxProps {
    heading: ReactNode;
    subHeading: ReactNode;
    statusBoxItems: StatusBoxProps[];
}

function RefundStatusBox(props: RefundStatusBoxProps) {
    const stackProps: StackProps = {
        sx: {
            gap: 2,
            padding: 2,
        },
    };

    const topStackProps: StackProps = {
        sx: {
            gap: 1,
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
        },
    };

    const headingProps: TypographyProps = {
        sx: {
            fontSize: 15,
            color: "#191B1E",
            fontWeight: 600,
        },
        children: props.heading,
    };

    const subHeadingProps: TypographyProps = {
        sx: {
            fontSize: 15,
            fontWeight: 500,
            color: "#27292C",
            textDecoration: "underline",
        },
        children: props.subHeading,
    };

    const middleStackProps: StackProps = {
        sx: {
            gap: 1,
            flexDirection: "row",
            alignItems: "center",
        },
    };

    return (
        <Stack {...stackProps}>
            <Stack {...topStackProps}>
                <Typography {...headingProps} />
                <Typography {...subHeadingProps} />
            </Stack>
            <Stack {...middleStackProps}>
                {props.statusBoxItems.map((item, index) => (
                    <StatusBox key={index} {...item} />
                ))}
            </Stack>
        </Stack>
    );
}

export default RefundStatusBox;
